import React from "react";

export const routeChangeType = {
    NO_CHANGE: 1,
    UPCOMING_ROUTE: 2,
    REPLACED_ROUTE: 3
};

export const scheduleType = {
    WEEKDAY: 'weekday',
    SATURDAY: 'saturday',
    SUNDAY: 'sunday'
}

export const getRouteChangeCopy = (route, returnReplacedCopy) => {
    const futureReplaceMsg = 'This route will be replaced soon.';
    const beginsMsg = 'This new route begins soon.';
    const replacedMsg = 'This route has been replaced.';
    let msg = null;

    if (isReplacedRoute(route)) {
        msg = futureReplaceMsg;
    }
    else if (isUpcomingRoute(route)) {
        msg = beginsMsg;
    }
    else if (returnReplacedCopy === true) {
        // fall through for routes that were previously replaced. 
        // these would not be in data after SC but user may be trying to access through shortcut, favorite etc
        msg = replacedMsg;
    }

    return msg;
}

export const showRouteChangeById = (route, routeStops) => {
    if (!route) {
        return false;
    }

    return getRouteChangeCopy(route, false) !== null ? true : false;
}

export const getRouteChangeElement = (route, returnReplacedCopy) => {
    const msg = getRouteChangeCopy(route, returnReplacedCopy);

    if (!msg) {
        return null;
    }

    return <div class="route-change-info">{msg} <a href="/servicechange" class="route-change-link">Learn more</a>.</div>;
}

export const getRouteChangeType = (route) => {
    if (isReplacedRoute(route)) {
        return routeChangeType.REPLACED_ROUTE;
    }
    else if (isUpcomingRoute(route)) {
        return routeChangeType.UPCOMING_ROUTE;
    }

    return routeChangeType.NO_CHANGE;
}

export const getRouteEndpointInfo = (params) => {
    let ret = '';
    let dir = -1;

    if (params.routeDirection) {
        dir = params.routeDirection === "0" ? (params.isStart ? "1" : "0") : (params.isStart ? "0" : "1");
    }

    if (params.route && params.routeDirection && params.routeSchedules && params.routeSchedules.length) {
        const direction = params[params.isPreview && params.routeScheduleWeekday ? 'routeScheduleWeekday' : 'routeSchedules'].find(d => d.direction_id == dir);

        if (direction) {
            if (direction.trip && direction.trip.length) {
                ret = direction.trip[params.isStart ? 0 : direction.trip.length - 1].trip_headsign;
            }
            if (direction.trips && direction.trips.length) {
                ret = direction.trips[direction.trips.length - 1].trip_headsign;
            }
        }
    }

    if (!ret && params.route && params.routeDirection && params.routeStops && params.routeStops.length) {
        const direction = params.routeStops.find(d => d.direction_id == params.routeDirection);
        
        if (direction && direction.stop && direction.stop.length) {
            ret = direction.stop[params.isStart ? 0 : direction.stop.length - 1].stop_name;
        }
    }

    return {
        name: ret,
        direction: dir
    };
};

export function getKeyStops(stops) {
    if (!Array.isArray(stops) || stops.length === 0) {
        return [];
    }

    const keyStops = stops.filter((s, si) => {
        if (s.timepoint == '1') {
            return true;
        }
        if (si == 0 || si == stops.length - 1) {
            return true;
        }
        if (/(pr|st|tc)$/.test(s.parent_station)) {
            return true;
        }
        if (/Bay [A-Z]?[0-9]+$/.test(s.stop_name)) {
            return true;
        }

        return false;
    });

    return keyStops;
};

function isReplacedRoute(route) {
    // replacedRoutes is a global variable defined in
    // ResourcePackages\Bootstrap4\MVC\Views\Layouts\CTBase.cshtml

    if (route && replacedRoutes.includes(route.toString())) {
        return true;
    }

    return false;
}

function isUpcomingRoute(route) {
    // upcomingRoutes is a global variable defined in
    // ResourcePackages\Bootstrap4\MVC\Views\Layouts\CTBase.cshtml

    if (route && upcomingRoutes.includes(route.toString())) {
        return true;
    }

    return false;
}